// Developers Tool — tabbed shell.
//
// Tab 1: API Keys (pre-existing functionality — content extracted to ApiKeysTab)
// Tab 2: Webhooks (new — WebhooksTab + WebhookConfigDialog)
//
// While impersonating a customer (2026-10-18) only the Webhooks tab exists:
// support needs to read/fix the customer's webhook config (e.g. Credit91's
// URL saved with a literal <webhook-secret>), but API keys are credentials and
// stay hidden. The API Keys tab and its content are not rendered at all, so a
// pasted /developers-tool URL cannot reveal them either.
//
// Tab state lives in component state. If deep-link-via-URL becomes a
// requirement we can sync to the query string (e.g. ?tab=webhooks).
import React, {Component} from 'react';
import {Tabs, Tab, Box, Link, Typography} from '@mui/material';

import ApiKeysTab from './ApiKeysTab';
import WebhooksTab from './WebhooksTab';
import {isImpersonating} from '../../lib/impersonation';

const API_DOC_LINK = 'https://docs.google.com/document/d/1kEozWoOkqS1foYWpE3Mlb8ZpbW9ks_LiiSq3B_i4568/edit?usp=sharing';

export default class DevelopersTool extends Component {
  state = {
    activeTab: 0,
  }

  handleTabChange = (_e, newValue) => this.setState({activeTab: newValue})

  render() {
    const {activeTab} = this.state;
    if (isImpersonating()) {
      return (
        <div className='sms-parent-container' style={window.isMobile && window.isMobile() ? {padding: 8} : {}}>
          <Typography variant="body1" style={{marginBottom: 16}}>
            Impersonating: only the Webhooks tab is shown. API keys stay hidden.
          </Typography>
          <Tabs value={0} style={{marginBottom: 16, borderBottom: '1px solid #e0e0e0'}}>
            <Tab label="Webhooks" />
          </Tabs>
          <Box>
            <WebhooksTab />
          </Box>
        </div>
      );
    }
    return (
      <div className='sms-parent-container' style={window.isMobile && window.isMobile() ? {padding: 8} : {}}>
        <Typography variant="body1" style={{marginBottom: 8}}>
          Use your API keys (in the API Keys tab) together with the documentation below to integrate with the API.
        </Typography>
        <Link href={API_DOC_LINK} target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', marginBottom: 16, fontSize: 16}}>
          View API Documentation
        </Link>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          style={{marginBottom: 16, borderBottom: '1px solid #e0e0e0'}}
        >
          <Tab label="API Keys" />
          <Tab label="Webhooks" />
        </Tabs>
        <Box>
          {activeTab === 0 && <ApiKeysTab />}
          {activeTab === 1 && <WebhooksTab />}
        </Box>
      </div>
    );
  }
}
